import { IconComponent } from '../icon.types';

export const AppleIcon: IconComponent = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.375 12.7632C19.3883 11.8433 19.6636 10.9413 20.1753 10.1412C20.6869 9.34111 21.4183 8.66888 22.3013 8.18706C21.7403 7.476 21.0003 6.89084 20.1399 6.47803C19.2796 6.06523 18.3227 5.83616 17.3451 5.80901C15.2599 5.61474 13.2384 6.91647 12.1757 6.91647C11.0926 6.91647 9.45653 5.8283 7.69478 5.86047C6.55523 5.89314 5.44465 6.18725 4.47125 6.71413C3.49785 7.24102 2.69482 7.98271 2.14041 8.86694C-0.26113 12.5573 1.53021 17.981 3.83072 20.964C4.98172 22.4247 6.3269 24.0564 8.08707 23.9985C9.80949 23.9351 10.4528 23.0237 12.5319 23.0237C14.5917 23.0237 15.1952 23.9985 16.9911 23.9618C18.8394 23.9351 20.0038 22.4945 21.1145 21.02C21.9415 19.9792 22.5778 18.8289 23 17.6117C21.9262 17.2086 21.0099 16.5339 20.3653 15.6717C19.7206 14.8095 19.3762 13.7979 19.375 12.7632Z"
      fill="currentColor"
    />
    <path
      d="M15.9829 3.84713C16.9906 2.77342 17.4871 1.39335 17.3669 0C15.8273 0.143519 14.4052 0.796596 13.3838 1.82911C12.8844 2.33351 12.502 2.92033 12.2583 3.55601C12.0146 4.19168 11.9144 4.86375 11.9636 5.5338C12.7336 5.54084 13.4955 5.3927 14.1917 5.10054C14.8879 4.80838 15.5003 4.37982 15.9829 3.84713Z"
      fill="currentColor"
    />
  </svg>
);
